import type { EngagedTopic, WorkMonitorItem } from './api'

export type EngagedTopicFilter = 'all' | 'done' | 'live' | 'snooze' | 'free'

const STATE_EVENTS = new Set([
  'agent_reply', 'enqueued', 'dispatched', 'replied', 'dispatch_error',
  'turn_active', 'turn_ended', 'turn_stopped', 'chat_read',
  'topic_created', 'topic_spawned', 'topic_closed', 'topic_reopened',
  'topic_renamed', 'topic_model_changed', 'snooze', 'unsnooze',
  'topic_engagement_done',
  'approval_request', 'approval_response',
])

export function changesEngagedTopicState(kind: string | undefined): boolean {
  return kind != null && (STATE_EVENTS.has(kind) || kind.startsWith('recheck_'))
}

export function engagedTopicState(
  topic: EngagedTopic,
  hasPendingOutbox = false,
  nowSeconds = Date.now() / 1000,
): 'done' | 'live' | 'snooze' {
  if ((topic.snoozed_until ?? 0) > nowSeconds) return 'snooze'
  // A queue held behind an unanswered question card waits on Mark.
  const queued = topic.queued && !topic.awaiting_answer
  if (topic.working || queued || (topic.side_job_work_depth ?? 0) > 0
      || hasPendingOutbox || topic.scheduled_recheck_at != null) return 'live'
  return 'done'
}

export function matchesEngagedTopicFilter(
  topic: EngagedTopic,
  filter: EngagedTopicFilter,
  hasPendingOutbox = false,
): boolean {
  if (topic.closed) return false
  if (filter === 'done' && topic.pending_approval) return true
  const state = engagedTopicState(topic, hasPendingOutbox)
  if (filter === 'done' && state !== 'snooze' && (topic.unread ?? 0) > 0) return true
  return filter === 'all' ? state !== 'snooze' : filter === state
}

export function isLongEngagedTopicWork(item: WorkMonitorItem, topics: readonly EngagedTopic[]): boolean {
  return item.topic_id != null && topics.some((topic) => (
    !topic.closed && topic.id === item.topic_id && topic.chat_id === item.chat_id && engagedTopicState(topic) === 'live'
  ))
}
